import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LoggedNav from "../components/LoggedNav";
import $ from "jquery";
import reminder from "../images/icons/reminder.png";
import ReCAPTCHA from "react-google-recaptcha";
import Dialog from "@mui/material/Dialog";
import { Box, Typography } from "@mui/material";
import LinkPayment from "./LinkPayment";
import toast from "react-hot-toast";

function Reminder(props) {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [bookingId, setBookingId] = useState("");
  const [bookerName, setBookerName] = useState("");
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const [showPaymentPopup, setShowPaymentPopup] = useState(false);
  const [showBdNotFoundPopup, setShowBdNotFoundPopup] = useState(false);
  const [bdNotFoundMessage, setBdNotFoundMessage] = useState("");

  const updateMealPrep = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!recaptchaToken) {
      setIsSubmitting(false);
      $(".validation").html("Please complete the reCAPTCHA");
      return;
    }

    if ($("input:checkbox[name=inp1]:checked").val() === undefined) {
      setIsSubmitting(false);
      $(".validation").html("Please turn off Burners/Oven");
      return;
    }

    if ($("input:checkbox[name=inp2]:checked").val() === undefined) {
      setIsSubmitting(false);
      $(".validation").html("Please load the Dish Washer");
      return;
    }

    if ($("input:checkbox[name=inp3]:checked").val() === undefined) {
      setIsSubmitting(false);
      $(".validation").html("Please clean the Kitchen");
      return;
    }

    $(".validation").html("");

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}status/chef_meal_preparation_complete`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            booking_id: bookingId.toString(),
            status: "6",
          }),
        }
      );

      const parsedData = await res.json();

      // ✅ SUCCESS
      if (parsedData.success === true) {
        localStorage.removeItem("reminder_bookingId");
        localStorage.removeItem("reminder_bookerName");

        setIsSubmitting(false);

        navigate("/chef/order-list", {
          state: { bookingId: bookingId, bookerName: bookerName },
        });

        return;
      }

      // ✅ PAYPAL NOT LINKED → OPEN PAYMENT POPUP
      if (parsedData.bd_found === false) {
        setIsSubmitting(false);
        setShowPaymentPopup(true);
        return;
      }

      // ✅ ADMIN CONTACT ERROR
      if (parsedData.status === false) {
        setIsSubmitting(false);
        setBdNotFoundMessage(
          parsedData.message ||
            "Kindly contact the Chef Republic admin for assistance."
        );
        setShowBdNotFoundPopup(true);
        return;
      }

    } catch (error) {
      setIsSubmitting(false);
      $(".validation").html(
        "Error while submitting. Please check your connection."
      );
      return;
    }
  };

  useEffect(() => {
    const title = "Reminder on Meal Prep Completion | CHEF | CHEF REPUBLIC";
    document.title = title;

    const savedBookingId = localStorage.getItem("reminder_bookingId");
    const savedBookerName = localStorage.getItem("reminder_bookerName");

    if (state?.bookingId || savedBookingId) {
      const finalBookingId = state?.bookingId || savedBookingId;
      setBookingId(finalBookingId);
      localStorage.setItem("reminder_bookingId", finalBookingId);
    } else {
      navigate(-1);
    }

    if (state?.bookerName || savedBookerName) {
      const finalBookerName = state?.bookerName || savedBookerName;
      setBookerName(finalBookerName);
      localStorage.setItem("reminder_bookerName", finalBookerName);
    } else {
      navigate(-1);
    }
  }, [state, navigate]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const merchantId = urlParams.get("merchantIdInPayPal");
    const email = urlParams.get("email");

    if (merchantId) {
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("logged_user_id");

      if (!token || !userId) {
        window.location.href = "/chef/sign-in";
        return;
      }

      saveMerchantIdToBackend(merchantId, email);

      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }, []);

  const saveMerchantIdToBackend = async (merchantId, email) => {
    try {
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("logged_user_id");

      const res = await fetch(
        "https://chefrepublicwebapi-dev.portalwiz.in/api/user/add_chef_account",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            user_id: userId,
            merchantId,
            Email: email,
            merchantIdInPayPal: merchantId,
            permissionsGranted: true,
            accountStatus: "active",
            consentStatus: "active",
            isEmailConfirmed: "true",
            returnMessage: "Onboarding complete",
          }),
        }
      );

      const data = await res.json();

      if (res.ok && data.success) {
        console.log("Merchant ID saved successfully.");
      } else if (res.status === 401) {
        localStorage.clear();
        window.location.href = "/chef/sign-in";
      } else {
        console.log(data.message || "Failed to save Merchant ID.");
      }
    } catch (err) {
      console.error("Save merchant error:", err);
    }
  };

  return (
    <>
      <LoggedNav customer={props.customer} />

      <div
        className="container d-flex flex-column justify-content-center align-items-center"
        style={{ width: "95%", margin: "auto", height: "80vh" }}
      >
        <div
          className="logo text-center fw-bold my-5 p-3"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#ff5e41",
            borderRadius: "50%",
            height: "100px",
            width: "100px",
          }}
        >
          <img src={reminder} alt="reminder" style={{ width: "95%" }} />
        </div>

        <h1 className="fw-bold">Reminder</h1>

        <div className="d-flex flex-column">
          <div className="form-check m-3">
            <input className="form-check-input" type="checkbox" value={1} name="inp1" />
            <label className="form-check-label">
              Please confirm that the Burners and oven if used are turned off
            </label>
          </div>

          <div className="form-check m-3">
            <input className="form-check-input" type="checkbox" value={1} name="inp2" />
            <label className="form-check-label">
              Please confirm that the dish washer is loaded
            </label>
          </div>

          <div className="form-check m-3">
            <input className="form-check-input" type="checkbox" value={1} name="inp3" />
            <label className="form-check-label">
              Please confirm the kitchen is clean
            </label>
          </div>
        </div>

        <p className="validation text-danger"></p>

        <div className="mb-3 text-center">
          <ReCAPTCHA
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            onChange={(token) => setRecaptchaToken(token)}
          />
        </div>

        <button
          onClick={updateMealPrep}
          className="btn-orange"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <span className="spinner-border spinner-border-sm"></span>
          ) : (
            "Confirm"
          )}
        </button>
      </div>

      <Dialog open={showPaymentPopup} onClose={() => setShowPaymentPopup(false)}>
        <Box sx={{ p: 3, textAlign: "center" }}>
          <Typography sx={{ fontSize: "16px", mb: 2 }}>
            Please link your PayPal Business account to accept payments
          </Typography>
          <LinkPayment />
        </Box>
      </Dialog>

      <Dialog open={showBdNotFoundPopup} onClose={() => setShowBdNotFoundPopup(false)}>
        <Box sx={{ p: 3, textAlign: "center" }}>
          <Typography sx={{ fontSize: "16px", mb: 2 }}>
            {bdNotFoundMessage}
          </Typography>

          <a
            href="mailto:support@chefrepublic.us"
            style={{ color: "#FF5E41", textDecoration: "underline" }}
          >
            Contact Us
          </a>
        </Box>
      </Dialog>
    </>
  );
}

export default Reminder;